import { FC, ReactNode } from "react";
import { Stack, Box } from "@mui/material";
import { NavLink } from "react-router-dom";
import { ApplicantsIcon, GridIcon, ListIcon } from "../../../MuiIcons";
import { CustomIconButton } from "../../../CustomIconButton";
import { useAuth } from "../../../../auth/useAuth";

const getIcons = (isSuperAdmin = false) => {
  return !isSuperAdmin
    ? [
        {
          image: <GridIcon />,
          alt: "Companies",
          path: "/companies",
        },
        {
          image: <ApplicantsIcon />,
          alt: "Verification requests",
          path: "/verification-requests",
        },
        {
          image: <ListIcon />,
          alt: "Config",
          path: "/config",
        },
      ]
    : [
        {
          image: <GridIcon />,
          alt: "Companies",
          path: "/companies",
        },
        {
          image: <ListIcon />,
          alt: "Config",
          path: "/config",
        },
      ];
};

type direction = "column" | "row" | "row-reverse" | "column-reverse";

interface ISideBarIconsProps {
  direction?: direction;
  children?: ReactNode;
}
export const SideBarIcons: FC<ISideBarIconsProps> = ({
  direction = "column",
}) => {
  const { isSuperAdmin } = useAuth();
  return (
    <Box>
      <Stack
        direction={direction}
        justifyContent='flex-start'
        alignItems='center'
        spacing={2}
      >
        <Stack
          direction={direction}
          justifyContent='space-between'
          alignItems='center'
          gap='8px'
        >
          {getIcons(isSuperAdmin).map(({ image, alt, path }) => (
            <CustomIconButton
              key={path}
              aria-label={alt}
              color='primary'
              // @ts-ignore
              component={NavLink}
              to={path}
              disableRipple
            >
              {image}
            </CustomIconButton>
          ))}
        </Stack>
      </Stack>
    </Box>
  );
};
